module.exports = __webpack_public_path__ + "img/home2.f3539ff8.jpg";